import { useContext, useState } from 'react';
import { FeatureSwitchContext } from '../context/featureSwitchApp';
import { useDealerDuck } from './useDealerDuck';
import useTranslations from './useTranslations';
import { getCurrentCulture } from '@utils/getCurrentCulture';

export const CATALAN_SPAIN_CULTURE = 'ca-ES';

export const useCatalanSwitch = () => {
    const [catalanSelected, setCatalanSelected] = useState(false);
    const handleToggleCatalan = () => setCatalanSelected(!catalanSelected);
    const { dealer } = useDealerDuck();
    const catalanZipPrefixes: string[] = (useContext(FeatureSwitchContext)?.FEATURE_SWITCH_CATALAN_ZIP_PREFIXES ?? '')
        .replace(/\s/g, '')
        .split(',');
    const { i18n } = useTranslations();
    const { currentCulture } = getCurrentCulture(i18n);

    const code = dealer?.zipCode ?? dealer?.postCode ?? (dealer?.address as { [key: string]: { zipCode: string } })?.[currentCulture]?.zipCode;
    const showCatalanSwitch = code && catalanZipPrefixes.includes(code.slice(0, 2));

    return { showCatalanSwitch, catalanSelected, handleToggleCatalan };
};
